<app-links-item *ngIf="date" [color]="color" [icon]="icon" [labels]="date.labels" [uid]="date.uid">
  <div app-links-item-content-description>
  </div>
  <div app-links-item-content-option class="d-flex align-items-center">
    <app-links-item-option class="d-block mx-1" [symbol]="'eye'" [selected]="selected" (sendSelected)="receiveSelected()"></app-links-item-option>
  </div>
</app-links-item>